module.exports = __webpack_public_path__ + "static/media/phone-icon.3358b096.svg";